import types from './types';

// QuartzController
const getAllJobs = (axiosConfig, keycloakConfig) => ({
	type: types.GET_ALL_JOBS,
	params: { axiosConfig, keycloakConfig }
});

const get = (axiosConfig, keycloakConfig, { group, name }) => ({
  type: types.GET,
	params: { axiosConfig, keycloakConfig, group, name }
});

const trigger = (axiosConfig, keycloakConfig, { group, name }) => ({
  type: types.TRIGGER,
	params: { axiosConfig, keycloakConfig, group, name }
});

const stop = (axiosConfig, keycloakConfig, { group, name }) => ({
  type: types.STOP,
	params: { axiosConfig, keycloakConfig, group, name }
});

const resume = (axiosConfig, keycloakConfig, { group, name }) => ({
  type: types.RESUME,
	params: { axiosConfig, keycloakConfig, group, name }
});

export default {
  getAllJobs,
  get,
  trigger,
  stop,
  resume
};
